/**
 * UNIVERSAL TABLE AUTO-FORMATTER
 * Removes inline styles from tables in:
 * - Product descriptions
 * - Metafields (rich text)
 * - Custom Liquid sections
 * - Blog posts
 * - Pages
 * - Any content area
 * 
 * Allows global CSS styling to work properly
 */

(function() {
  'use strict';
  
  function cleanAllTables() {
    // Find ALL tables on the page - no restrictions!
    // This catches tables in descriptions, metafields, custom sections, etc.
    const allTables = document.querySelectorAll('table');
    
    let cleanedCount = 0;
    
    allTables.forEach(function(table) {
      // Skip tables that should keep their styles (like cart tables, data tables)
      // Only skip if they have specific data attributes or classes indicating they're functional tables
      const skipClasses = ['cart-table', 'data-table', 'admin-table'];
      const shouldSkip = skipClasses.some(function(className) {
        return table.classList.contains(className);
      });
      
      if (shouldSkip) return;
      
      // Clean table element itself
      if (table.hasAttribute('width')) table.removeAttribute('width');
      if (table.hasAttribute('height')) table.removeAttribute('height');
      if (table.hasAttribute('style')) table.removeAttribute('style');
      
      // Clean all table cells (td and th)
      const cells = table.querySelectorAll('td, th');
      cells.forEach(function(cell) {
        if (cell.hasAttribute('width')) cell.removeAttribute('width');
        if (cell.hasAttribute('height')) cell.removeAttribute('height');
        if (cell.hasAttribute('style')) cell.removeAttribute('style');
      });
      
      // Clean all table rows
      const rows = table.querySelectorAll('tr');
      rows.forEach(function(row) {
        if (row.hasAttribute('style')) row.removeAttribute('style');
      });
      
      // Clean tbody/thead/tfoot
      const sections = table.querySelectorAll('tbody, thead, tfoot');
      sections.forEach(function(section) {
        if (section.hasAttribute('style')) section.removeAttribute('style');
      });
      
      cleanedCount++;
    });
    
    if (cleanedCount > 0) {
      console.log('✅ Cleaned ' + cleanedCount + ' table(s) - APEX styling applied');
    }
  }
  
  // Run immediately on script load
  cleanAllTables();
  
  // Run after DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanAllTables);
  }
  
  // Run after all resources are loaded (images, etc.)
  window.addEventListener('load', cleanAllTables);
  
  // Watch for dynamically added content (metafields loaded via JS, etc.)
  if (window.MutationObserver) {
    let timeoutId;
    const observer = new MutationObserver(function() {
      // Debounce - wait 100ms after last change before cleaning
      clearTimeout(timeoutId);
      timeoutId = setTimeout(cleanAllTables, 100);
    });
    
    // Observe the entire body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // For Shopify section rendering (theme editor, dynamic sections)
  document.addEventListener('shopify:section:load', cleanAllTables);
  document.addEventListener('shopify:section:reorder', cleanAllTables);
  
})();